export type SubscriptionPeriod = '30' | '365';

/**
 * 일시납 종류에는 1일, 3일, 1개월 - 12개월까지 있고 string 으로 서버에 요청한다.
 */
export type OnetimePeriod =
  | '1D'
  | '3D'
  | '1M'
  | '2M'
  | '3M'
  | '4M'
  | '5M'
  | '6M'
  | '7M'
  | '8M'
  | '9M'
  | '10M'
  | '11M'
  | '12M';

export type CustomOnetimePeriod = Omit<OnetimePeriod, '1D' | '3D'>;

export enum PlanTemplateType {
  PRODUCT_SUBSCRIPTION = '1',
  CUSTOM_SUBSCRIPTION = '2',
  PRODUCT_ONETIME = '3',
}

export type PlanTemplateKey = keyof typeof PlanTemplateType;

export type PriceLocale = 'ko' | 'en';

export type PlanPrices = {
  basic: number;
  pro: number;
  saleRate?: number;
};

export type PlanPaymentMethodType = {
  monthly: PlanPrices;
  yearly: PlanPrices;
  oneDay: PlanPrices;
  threeDay: PlanPrices;
  customMonth: PlanPrices;
};

export type PlanPricesType = {
  [key in PriceLocale]: PlanPaymentMethodType;
};

export type PaymentStatusType =
  | 'RESERVED_GRADE'
  | 'SAME_GRADE'
  | 'UP_GRADE'
  | 'DOWN_GRADE'
  | 'NONE_UPGRADE';

export type TossWidgetVariantKey = 'ONETIME_OVER_300' | 'ONETIME_UNDER_300';
